import type { HTMLAttributes, ImgHTMLAttributes } from "react";

/** shadcn/ui 风格头像容器。 */
export function Avatar({ className = "", ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span data-slot="avatar" className={`fm-shadcn-avatar ${className}`.trim()} {...props} />;
}

/** 头像图片。 */
export function AvatarImage({ className = "", ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  return <img data-slot="avatar-image" className={`fm-shadcn-avatar-image ${className}`.trim()} {...props} />;
}

/** 图片不可用时显示的头像回退内容。 */
export function AvatarFallback({ className = "", ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span data-slot="avatar-fallback" className={`fm-shadcn-avatar-fallback ${className}`.trim()} {...props} />;
}
